import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 26033 37241"
    {...props}
  >
    <path
      d="M19113 20336c-1096 1299-2318 2276-3668 2929-1350 654-2853 985-4492 985-1562 0-3014-306-4373-908-1350-603-2522-1452-3506-2539-986-1087-1750-2352-2276-3804C263 15547 0 14027 0 12439c0-1714 297-3328 900-4865 594-1536 1452-2862 2556-3991C4568 2454 5892 1580 7429 942 8966 314 10664 0 12515 0c2140 0 4050 391 5732 1172 1672 773 3082 1911 4228 3388 1146 1486 2021 3354 2641 5612 611 2251 917 4806 917 7651 0 3184-323 5986-968 8414-654 2428-1588 4466-2828 6122-1239 1647-2717 2870-4440 3677-1724 806-3686 1205-5876 1205-2157 0-4033-407-5621-1231-1596-815-2811-1834-3634-3048-832-1223-1248-2395-1248-3516 0-695 255-1315 772-1867 518-544 1172-815 1970-815 730 0 1384 203 1962 611 585 399 1019 1010 1324 1825 365 994 968 1792 1817 2395 841 603 1800 908 2862 908 942 0 1842-237 2683-721 849-476 1570-1164 2165-2038 1197-1775 1910-4908 2140-9408zm-569-7616c0-1121-153-2166-459-3117-306-950-739-1774-1299-2471-552-696-1214-1247-1987-1647-772-399-1613-594-2530-594-1571 0-2912 679-4008 2029-1095 1350-1639 3134-1639 5358 0 2199 544 3957 1639 5273 1096 1307 2488 1961 4161 1961 1027 0 2012-271 2946-806 943-544 1707-1325 2293-2353 586-1027 883-2241 883-3633z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
